import { Box, Paper, Typography, Skeleton, Stack, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getRide } from "../../services/card.service";
import useAlerts from "../../hooks/useAlerts";
import { useTranslation } from "react-i18next";
import Chat from "../common/chat/Chat";
import DocumentMedia from "../common/documentMedia/DocumentMedia";
import RideGroupElement from "../common/ride/components/RideGroupElement";
import ICardGroupItem from "../../types/ICardGroupItem";
import { ICardGroupWithItems } from "../../types/ICardGroup";
import RideGroupItem from "../common/ride/components/RideGroupItem";
import AccessTimeFilledOutlinedIcon from "@mui/icons-material/AccessTimeFilledOutlined";
import Person from "@mui/icons-material/Person";
import School from "@mui/icons-material/School";
import Percent from "@mui/icons-material/Percent";
import IReport from "../../types/IReport";
import { themePalette } from "../../themes/palette";
import FileUpload from "../common/fileUpload/FileUpload";
import { ICardWithGroupWithItems } from "../../types/ICard";
import { uploadFileReportChange } from "../../services/report.service";
import { IPublicFile } from "../../types/IPublicFile";

const ViewReport = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { id = 0 } = useParams();

  const { error, success } = useAlerts();

  const [ride, setRide] = useState<IReport>();
  const [card, setCard] = useState<ICardWithGroupWithItems>();
  const [comments, setComments] = useState<any>([]);
  const [files, setFiles] = useState<IPublicFile[]>([]);

  function handleFileUpload(file: File) {
    if (ride) {
      uploadFileReportChange(ride.id, file)
        .then((data) => {
          setFiles(data.data.files);
          success();
        })
        .catch((err) => {
          error();
        });
    }
  }

  function handleFileRemove(fileId: number) {
    if (ride) {
    }
  }

  // function getMaxPoints(index: number) {
  //   return card.groups[index].items.reduce(function (prev: any, current: any) {
  //     return prev + current.points;
  //   }, 0);
  // }
  function getMaxPoints(index: number) {
    return card?.groups[index].items.reduce(function (prev: any, current: any) {
      return prev + current.points;
    }, 0);
  }

  // function getAnswersPoints(groupId: number) {
  //   const groupItems = ride?.card.groups.find((x: any) => x.id === groupId)?.items;
  //   if (!groupItems) return 0;

  //   let score = 0;

  //   for (let i = 0; i < groupItems?.length; i++) {
  //     const currentId = groupItems[i].id;
  //     if (ride?.answers[currentId] !== undefined) {
  //       score += ride?.answers[currentId];
  //     }
  //   }

  //   return score;
  // }

  useEffect(() => {
    let isMounted = false;

    if (id) {
      getRide(id)
        .then((data) => {
          if (isMounted) return;

          // if (data.data.endedAt) {
          data.data.card.groups.sort((a: ICardGroupWithItems, b: ICardGroupWithItems) =>
            a.index > b.index ? 1 : -1
          );

          setRide(data.data);
          setCard(data.data.card);
          setComments(data.data.comments);
          setFiles(data.data.files || []);

          // } else {
          // warning(t("Ewaluacja trwa"));
          // navigate(R_RIDE(data.data.id));
          // }

          //todo odblokowanie widoku karty przed zapisem
        })
        .catch((err) => {
          if (err.response.status !== 401) {
            error();
          }
        });
    }

    return () => {
      isMounted = true;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getGroupPoints = (group: ICardGroupWithItems, answers: Record<number, number>) => {
    const itemIds = group.items.reduce((acc, item) => {
      acc.push(item.id);
      return acc;
    }, [] as number[]);
    return itemIds.reduce((acc, id) => {
      return acc + answers[id];
    }, 0);
  };

  const iconParams = {
    sx: {
      marginRight: "5px",
      verticalAlign: "bottom"
    }
  };

  const HeaderSeparator = () => <Box sx={{ marginTop: "10px" }}></Box>;

  return (
    <Box>
      {!ride && <Skeleton animation="wave" sx={{ width: "100%" }} />}
      {ride && (
        <Box>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            mb={2}
          >
            <Link
              to=""
              className="back_button"
              onClick={() => navigate(-1)}
              style={{ textDecoration: "none", color: themePalette.primary.main }}
            >
              <ArrowBackIcon sx={{ verticalAlign: "top" }} /> <span>{t("Wstecz")}</span>
            </Link>
          </Stack>

          <Paper sx={{ p: 2 }}>
            {/* <Typography marginBottom={2} component="h2" variant="h6">
              {t("Ogólne informacje")}
            </Typography> */}
            <Typography>
              <AccessTimeFilledOutlinedIcon color="primary" {...iconParams} />
              {t("Data")}:{" "}
              <strong>
                {new Date(ride.createdAt).toLocaleDateString("pl-PL")}{" "}
                {new Date(ride.createdAt).toLocaleTimeString(["pl-PL"], {
                  hour: "2-digit",
                  minute: "2-digit"
                })}
              </strong>
            </Typography>
            <HeaderSeparator />
            <Typography>
              <Person color="secondary" {...iconParams} />
              {t("Egzaminator")} - <strong>{ride?.instructor?.name}</strong>
            </Typography>
            <HeaderSeparator />
            <Typography>
              <School color="primary" {...iconParams} />
              {t("Uczestnik")} - <strong>{ride?.user?.name}</strong> ({ride?.user?.email})
            </Typography>
            <HeaderSeparator />
            <Typography>
              <Percent color="primary" {...iconParams} />
              {t("Ocena całościowa")} - <strong>{ride.result}%</strong>
            </Typography>
          </Paper>
          <Box sx={{ width: "100%", height: "20px" }}></Box>

          <Box marginTop={4} paddingBottom={0}>
            <Paper sx={{ pb: 2, pl: 2, pr: 2, pt: 2 }}>
              <FileUpload
                canUpload={false}
                files={files}
                onRemoveFile={handleFileRemove}
                onUpload={handleFileUpload}
              />
            </Paper>
          </Box>

          <Box marginTop={4} paddingBottom={0}>
            <Paper sx={{ pb: 2, pl: 1, pr: 1 }}>
              {ride?.id && <Chat chatKey={`ride-${ride.id}`} />}
            </Paper>
          </Box>

          {card?.groups?.map((group: ICardGroupWithItems, index: number) => (
            <Grid item xs={12} key={index}>
              <RideGroupElement
                group={group}
                index={index}
                points={ride.result && getGroupPoints(group, ride.answers)}
              >
                <>
                  {group.items.map((item: ICardGroupItem, index: number) => (
                    <RideGroupItem
                      reportDesc={ride?.report[item.id]}
                      comment={ride?.comments[item.id]}
                      item={item}
                      points={ride?.answers[item.id]}
                      key={index}
                    />
                  ))}
                </>
              </RideGroupElement>
            </Grid>
          ))}

          {/* <Grid marginTop={3} container spacing={3}>
            {card?.groups?.map((group: any, index: number) => (
              <Grid item key={index} xs={12} md={6}>
                <Paper>
                  <Box p={2}>
                    <Typography variant="h6">{group.name[getLanguage()]}</Typography>

                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Box sx={{ width: "100%", mr: 1 }}>
                        <LinearProgress
                          variant="determinate"
                          value={(getAnswersPoints(group.id) / getMaxPoints(index)) * 100}
                        />
                      </Box>
                      <Box sx={{ minWidth: 35 }}>
                        <Typography variant="body2" color="text.secondary">
                          {getAnswersPoints(group.id)} / {getMaxPoints(index)}
                        </Typography>
                      </Box>
                    </Box>

                    <Divider />

                    <Box marginTop={0}>
                      <List>
                        {group?.items?.map((item: any, index: number) => (
                          <ListItem divider key={index}>
                            <ListItemAvatar>
                              <Avatar>
                                <Box
                                  sx={{
                                    position: "relative",
                                    display: "inline-flex"
                                  }}
                                >
                                  <CircularProgress
                                    variant="determinate"
                                    value={(ride.answers[item.id] / item.points) * 100}
                                  />
                                  <Box
                                    sx={{
                                      top: 0,
                                      left: 0,
                                      bottom: 0,
                                      right: 0,
                                      position: "absolute",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center"
                                    }}
                                  >
                                    <Typography
                                      variant="caption"
                                      component="div"
                                      color="text.secondary"
                                    >
                                      {ride.answers[item.id]} / {item.points}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Avatar>
                            </ListItemAvatar>
                            <Stack width={"100%"}>
                              <Accordion expanded={true} disableGutters>
                                <AccordionSummary>{item.name[getLanguage()]}</AccordionSummary>
                              </Accordion>
                              <Accordion disabled={!ride.report[item.id]}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                  {t("Raport")}
                                </AccordionSummary>
                                <AccordionDetails>
                                  {ride.report[item.id] && ride.report[item.id][getLanguage()]}
                                </AccordionDetails>
                              </Accordion>
                              <Accordion disabled={!ride.comments[item.id]}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                  {t("Komentarz")}
                                </AccordionSummary>
                                <AccordionDetails>{ride.comments[item.id]}</AccordionDetails>
                              </Accordion>
                            </Stack>
                          </ListItem>
                        ))}
                      </List>
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid> */}

          {/* Fixed instructor comments */}
          {/* {ride.comments && Object.keys(ride.comments).length > 0 && (
            <>
            <Paper sx={{ p: 3, py: 2, mt: 2, width: '100%' }}>
              <Box
                sx={{
                  display: "inline-flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%"
                }}
              >
                <Typography component="h2" variant="h6">
                  {t("Komentarze od instruktora")}:
                </Typography>
              </Box>
              </Paper>
              <Paper sx={{ p: { xs: 2, sm: 3 }, mt: 2, mb: 0 }}>
                
                {Object.values(ride.comments).map((comment: string, index: number) => (
                  <Box sx={{ mt: 0, mb: 1 }} key={index}>
                    <Typography>{comment}</Typography>
                  </Box>
                ))}
              </Paper>
            </>
          )} */}
        </Box>
      )}
      <Box marginTop={4} paddingBottom={2}>
        <Paper sx={{ pb: 2, pl: 1, pr: 1 }}>
          {ride?.id && <DocumentMedia mediaKey={`ride-${ride.id}`} />}
        </Paper>
      </Box>
      <Box marginTop={4} paddingBottom={2}>
        <Paper sx={{ pb: 2, pl: 1, pr: 1 }}>
          {ride?.id && <Chat chatKey={`ride-${ride.id}`} />}
        </Paper>
      </Box>
    </Box>
  );
};

export default ViewReport;
